import api from "./api";

export const showroomService = {

  // 📊 Get showroom performance
  getPerformance: async () => {
    try {
      const res = await api.get("/showroom-performance");
      return res.data;
    } catch (error) {
      throw error;
    }
  }

};